module.exports = __webpack_public_path__ + "static/media/  (55).8c9211c4.jpg";